<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>保险-工伤手续办理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNew">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AmountUnderwriting" label="保司垫资金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WarrantyTime" label="保司垫资时间" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark1" label="保司垫资备注" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InvoiceValue" label="发票金额" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SickDays" label="病假天数情况" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.EstimateAmountInsurance" label="预估商保赔偿款" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IsInsuranceArrived" label="商保是否已到账" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IdentificationDataSubmitted" label="工伤认定资料提交人社局时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IdentifiedInjuryTime" label="认定为工伤时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AppraisalSubmitTime" label="工伤鉴定资料提交时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.DisabilityDegree" label="伤残等级" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IdentifyInjuryGradeTime" label="鉴定出工伤等级时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AppraisalInstitution" label="工伤鉴定机构" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SubmitInforInsuranceCompany" label="报销资料提交保司情况" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.PhotoInjured" label="伤者照片提交情况" width="125" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark2" label="工伤手续办理情况备注" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ClaimDetails1" label="赔付明细1（社保）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.PaymentAmount1" label="赔付金额" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ClaimDetails2" label="赔付明细2（商保1）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.PaymentAmount2" label="赔付金额" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ClaimDetails3" label="赔付明细3（商保2）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.PaymentAmount3" label="赔付金额" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Total" label="合计赔付金额" width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark3" label="赔付明细备注" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryFinalised" label="工伤是否终结" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark4" label="工伤是否终结备注" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="90px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司垫资金额" prop="AmountUnderwriting">
            <el-input v-model="formData.AmountUnderwriting" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司垫资时间" prop="WarrantyTime">
            <el-date-picker type="date" placeholder="" v-model="formData.WarrantyTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="保司垫资备注" prop="Remark1">
            <el-input v-model="formData.Remark1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="发票金额" prop="InvoiceValue">
            <el-input v-model="formData.InvoiceValue" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="病假天数情况" prop="SickDays">
            <el-input v-model="formData.SickDays" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="预估商保赔偿款" prop="EstimateAmountInsurance">
            <el-input v-model="formData.EstimateAmountInsurance" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保是否已到账" prop="IsInsuranceArrived">
            <el-input v-model="formData.IsInsuranceArrived" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤认定资料提交人社局时间" prop="IdentificationDataSubmitted">
            <el-date-picker type="date" placeholder="" v-model="formData.IdentificationDataSubmitted" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="认定为工伤时间" prop="IdentifiedInjuryTime">
            <el-date-picker type="date" placeholder="" v-model="formData.IdentifiedInjuryTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤鉴定资料提交时间" prop="AppraisalSubmitTime">
            <el-date-picker type="date" placeholder="" v-model="formData.AppraisalSubmitTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="伤残等级" prop="DisabilityDegree">
            <el-select v-model="formData.DisabilityDegree" placeholder="" clearable size="small" style="width:300px">
              <el-option value="无"></el-option>
              <el-option value="十级"></el-option>
              <el-option value="九级"></el-option>
              <el-option value="八级"></el-option>
              <el-option value="七级"></el-option>
              <el-option value="六级"></el-option>
              <el-option value="五级"></el-option>
              <el-option value="四级"></el-option>
              <el-option value="三级"></el-option>
              <el-option value="二级"></el-option>
              <el-option value="一级"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="鉴定出工伤等级时间" prop="IdentifyInjuryGradeTime">
            <el-date-picker type="date" placeholder="" v-model="formData.IdentifyInjuryGradeTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤鉴定机构" prop="AppraisalInstitution">
            <el-select v-model="formData.AppraisalInstitution" placeholder="" clearable size="small" style="width:300px">
              <el-option value="司法鉴定"></el-option>
              <el-option value="人社局鉴定"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="SubmitInforInsuranceCompany">
            <template #label>
              <span>报销资料提交保司情况
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>如：2023-12-31给太保报销</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.SubmitInforInsuranceCompany" style="width:300px" size="small"></el-input>
          </el-form-item>
          <!-- <div>
            <el-form-item label="伤者照片" prop="name">
              <el-upload action="" list-type="picture-card" 
              accept=".png,.jpg,.gif"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemovePic" :on-change="handleChangePic" :on-exceed="handleExceedPic" :auto-upload="false" :multiple="false" :limit="9" :file-list="PicList">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisiblePic" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </div> -->
          <el-form-item label="伤者照片提交情况" prop="PhotoInjured">
            <el-input v-model="formData.PhotoInjured" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤手续办理情况备注" prop="Remark2">
            <el-input v-model="formData.Remark2" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付明细1（社保）" prop="ClaimDetails1">
            <el-input v-model="formData.ClaimDetails1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付金额" prop="PaymentAmount1">
            <el-input v-model="formData.PaymentAmount1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付明细2（商保1）" prop="ClaimDetails2">
            <el-input v-model="formData.ClaimDetails2" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付金额" prop="PaymentAmount2">
            <el-input v-model="formData.PaymentAmount2" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付明细3（商保2）" prop="ClaimDetails3">
            <el-input v-model="formData.ClaimDetails3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付金额" prop="PaymentAmount3">
            <el-input v-model="formData.PaymentAmount3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="合计赔付金额" prop="Total">
            <el-input v-model="formData.Total" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赔付明细备注" prop="Remark3">
            <el-input v-model="formData.Remark3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="InjuryFinalised">
            <template #label>
              <span>工伤是否终结
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>以全部赔偿款杰博到账为准</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="formData.InjuryFinalised" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤是否终结备注" prop="Remark4">
            <el-input v-model="formData.Remark4" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],
        totalCount: 0,
        PicList: [],
        injuredPic: [],
        dialogVisiblePic: false,
        dialogImageUrl: '',
        loading: false,
        showAdd: false,
        formData: {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          AmountUnderwriting: '', //保司垫资金额
          WarrantyTime: '', //保司垫资时间
          Remark1: '', //备注1
          InvoiceValue: '', //发票金额
          SickDays: '', //病假天数情况
          EstimateAmountInsurance: '', //预估商保赔偿款
          IsInsuranceArrived: '', //商保是否已到账
          IdentificationDataSubmitted: '', //工伤认定资料提交人社局时间
          IdentifiedInjuryTime: '', //认定为工伤时间
          AppraisalSubmitTime: '', //工伤鉴定资料提交时间
          DisabilityDegree: '', //伤残等级
          IdentifyInjuryGradeTime: '', //鉴定出工伤等级时间
          AppraisalInstitution: '', //工伤鉴定机构（司法鉴定/人社局鉴定）
          SubmitInforInsuranceCompany: '', //报销资料提交保司情况
          PhotoInjured: '', //伤者照片
          Remark2: '', //备注2
          ClaimDetails1: '', //赔付明细1（社保）
          PaymentAmount1: '', //赔付金额1
          ClaimDetails2: '', //赔付明细2（商保1）
          PaymentAmount2: '', //赔付金额2
          ClaimDetails3: '', //赔付明细3（商保2）
          PaymentAmount3: '', //赔付金额3
          Total: '', //合计
          Remark3: '', //备注3
          InjuryFinalised: '', //工伤是否终结
          Remark4: '', //备注4
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请选择发生工伤日期',
            trigger: 'change'
          },
          AmountUnderwriting: {
            required: true,
            message: '请输入保司垫资金额',
            trigger: 'blur'
          },
          WarrantyTime: {
            required: true,
            message: '请输入保司垫资时间',
            trigger: 'blur'
          },
          Remark1: {
            required: true,
            message: '请输入保司垫资备注',
            trigger: 'blur'
          },
          InvoiceValue: {
            required: true,
            message: '请输入发票金额',
            trigger: 'blur'
          },
          SickDays: {
            required: true,
            message: '请输入病假天数',
            trigger: 'blur'
          },
          EstimateAmountInsurance: {
            required: true,
            message: '请输入预估商保赔偿款',
            trigger: 'blur'
          },
          IsInsuranceArrived: {
            required: true,
            message: '请输入商保是否已到账',
            trigger: 'blur'
          },
          IdentificationDataSubmitted: {
            required: true,
            message: '请选择工伤认定资料提交人社局时间',
            trigger: 'change'
          },
          IdentifiedInjuryTime: {
            required: true,
            message: '请选择认定为工伤时间',
            trigger: 'change'
          },
          AppraisalSubmitTime: {
            required: true,
            message: '请选择工伤鉴定资料提交时间',
            trigger: 'change'
          },
          DisabilityDegree: {
            required: true,
            message: '请选择伤残等级',
            trigger: 'change'
          },
          IdentifyInjuryGradeTime: {
            required: true,
            message: '请选择鉴定出工伤等级时间',
            trigger: 'change'
          },
          AppraisalInstitution: {
            required: true,
            message: '请输入工伤鉴定机构',
            trigger: 'blur'
          },
          SubmitInforInsuranceCompany: {
            required: true,
            message: '请输入报销资料提交保司情况',
            trigger: 'blur'
          },
          PhotoInjured: {
            required: true,
            message: '请输入伤者照片提交情况',
            trigger: 'blur'
          },
          Remark2: {
            required: true,
            message: '请输入工伤手续办理情况备注',
            trigger: 'blur'
          },
          ClaimDetails1: {
            required: true,
            message: '请输入赔付明细1（社保）',
            trigger: 'blur'
          },
          PaymentAmount1: {
            required: true,
            message: '请输入赔付金额',
            trigger: 'blur'
          },
          ClaimDetails2: {
            required: true,
            message: '请输入赔付明细2（商保1）',
            trigger: 'blur'
          },
          PaymentAmount2: {
            required: true,
            message: '请输入赔付金额',
            trigger: 'blur'
          },
          ClaimDetails3: {
            required: true,
            message: '请输入赔付明细3（商保2）',
            trigger: 'blur'
          },
          PaymentAmount3: {
            required: true,
            message: '请输入赔付金额',
            trigger: 'blur'
          },
          Total: {
            required: true,
            message: '请输入合计赔付金额',
            trigger: 'blur'
          },
          Remark3: {
            required: true,
            message: '请输入赔付明细备注',
            trigger: 'blur'
          },
          InjuryFinalised: {
            required: true,
            message: '请输入工伤是否终结',
            trigger: 'blur'
          },
          Remark4: {
            required: true,
            message: '请输入工伤是否终结备注',
            trigger: 'blur'
          }
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
        roletype:localStorage.loginRoletype,
      }
    },
    created() {
      this.getWiinsuranceGroup3List();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiinsuranceGroup3List();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiinsuranceGroup3List();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWiinsuranceGroup3List();
      },
      //取保险组-工伤手续办理列表
      getWiinsuranceGroup3List() {
        this.loading = true;
        xz.getWiinsuranceGroup3List(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增
      addNew() {
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        //取【3】保险组-工伤手续办理详情
        xz.getWiinsuranceGroup3(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
          } else {
            this.formData = item;
          }
          this.showAdd = true;
        })
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiinsuranceGroup3(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiinsuranceGroup3List();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //删除【3】保险组-工伤手续办理详情
      del(item) {
        xz.delWiinsuranceGroup3(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiinsuranceGroup3List();
            this.$message.success('作废成功！')
          } else {
            this.getWiinsuranceGroup3List();
            this.$message.error(res.msg)
          }
        })
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          AmountUnderwriting: '', //保司垫资金额
          WarrantyTime: '', //保司垫资时间
          Remark1: '', //备注1
          InvoiceValue: '', //发票金额
          SickDays: '', //病假天数情况
          EstimateAmountInsurance: '', //预估商保赔偿款
          IsInsuranceArrived: '', //商保是否已到账
          IdentificationDataSubmitted: '', //工伤认定资料提交人社局时间
          IdentifiedInjuryTime: '', //认定为工伤时间
          AppraisalSubmitTime: '', //工伤鉴定资料提交时间
          DisabilityDegree: '', //伤残等级
          IdentifyInjuryGradeTime: '', //鉴定出工伤等级时间
          AppraisalInstitution: '', //工伤鉴定机构（司法鉴定/人社局鉴定）
          SubmitInforInsuranceCompany: '', //报销资料提交保司情况
          PhotoInjured: '', //伤者照片
          Remark2: '', //备注2
          ClaimDetails1: '', //赔付明细1（社保）
          PaymentAmount1: '', //赔付金额1
          ClaimDetails2: '', //赔付明细2（商保1）
          PaymentAmount2: '', //赔付金额2
          ClaimDetails3: '', //赔付明细3（商保2）
          PaymentAmount3: '', //赔付金额3
          Total: '', //合计
          Remark3: '', //备注3
          InjuryFinalised: '', //工伤是否终结
          Remark4: '', //备注4
        }
      },
      handleChangePic(file) {
        let maxSize = 1024 * 1024 * 5;
        if (file.size <= maxSize) {
          this.uploadImg(file.raw);
        } else {
          xz.imgCompress(file.raw).then((f) => {
            if (f) {
              this.uploadImg(f)
            }
          });
        }
      },
      uploadImg(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "entimg");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.injuredPic.push({
              id: "",
              url: res,
            });
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //图片预览
      handlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisiblePic = true;
      },
      //删除图片
      handleRemovePic(file, fileList) {
        console.log(file, fileList);
        this.injuredPic.forEach((ele, index) => {
          if ((ele) => file.Id === ele.Id) {
            this.injuredPic.splice(index, 1);
          }
        });
        console.log(this.PicList);
      },
      handleExceedPic() {
        this.$message.warning(`最多上传9张图片！`);
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 128px;
  }

  .page_injuryTables .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }
</style>